export default __webpack_public_path__ + "static/media/logo-001.4dc712d0.png";